import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useAboutController } from '../controllers/AboutController';
import AboutShimmer from '../views/components/AboutShimmer';
import SectionWrapper from '../views/components/SectionWrapper';
import { FaCheckCircle, FaTrophy } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

export default function AboutView() {
  const { t } = useLanguage();
  const { data, loading, error } = useAboutController();

  useEffect(() => {
    if (data) AOS.refresh();
  }, [data]);

  if (loading) return <AboutShimmer />;
  if (error) return <div className="alert alert-danger">{t('errors.about')}</div>;

  const {
    name,
    bio,
    avatar,
    skills = [],
    achievements = []
  } = data;

  return (
    <SectionWrapper id="about">
      <div className="about-card mx-auto text-white" data-aos="fade-up">
        <div className="row align-items-center">
          <div className="col-md-4 text-center mb-4 mb-md-0">
            <div className="profile-avatar-wrapper mx-auto">
              <img
                src={avatar}
                alt={t('about.avatarAlt', { name })}
                className="profile-avatar"
              />
            </div>
          </div>

          <div className="col-md-8">
            <small className="section-subtitle">{t('about.subtitle')}</small>
            <h2 className="profile-name">{name}</h2>
            <p className="bio">{bio}</p>

            <div className="row mt-4">
              <div className="col-sm-6">
                <h5 className="subheading">{t('about.skills')}</h5>
                <ul className="list-unstyled feature-list">
                  {skills.map((skill, i) => (
                    <li key={i}>
                      <FaCheckCircle className="feature-icon" />
                      {skill}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-sm-6">
                <h5 className="subheading">{t('about.achievements')}</h5>
                <ul className="list-unstyled feature-list">
                  {achievements.map((achievement, i) => (
                    <li key={i}>
                      <FaTrophy className="feature-icon" />
                      {achievement}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="text-center mt-4">
              <a href="/contact" className="btn btn-accent btn-lg">
                {t('about.cta')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
